<section class="abha-consent" [attr.aria-label]="'ABHA.CONSENT_TITLE' | translate">
  <div class="abha-consent-title">{{ 'ABHA.CONSENT_TITLE' | translate }}</div>
  <div class="abha-consent-text">
    <ol>
      <li *ngFor="let pointKey of consentPointKeys">{{ pointKey | translate }}</li>
    </ol>
    <p>{{ 'ABHA.CONSENT_STAFF' | translate }}</p>
    <p>{{ 'ABHA.CONSENT_BENEFICIARY' | translate }}</p>
  </div>
  <mat-checkbox color="primary" [formControl]="control">
    {{ 'ABHA.CONSENT_AGREE' | translate }}
  </mat-checkbox>
  <div class="abha-consent-error" *ngIf="isMissing">
    {{ 'ABHA.CONSENT_REQUIRED' | translate }}
  </div>
</section>
